import { 
    AllergyCategoryEnum, 
    AllergySeverityEnum,
    AllergyCriticalityEnum,
    AllergyStatusEnum, } 
    from "../../Types/Enums/AllergyEnum";


// --- ALLERGY MAPS ---

export const ALLERGY_CATEGORY_MAP = [
    { id: AllergyCategoryEnum.UNSPECIFIED, labels: { 0: "Sin especificar", 1: "Unspecified" } },
    { id: AllergyCategoryEnum.FOOD, labels: { 0: "Alimento", 1: "Food" } },
    { id: AllergyCategoryEnum.MEDICATION, labels: { 0: "Medicamento", 1: "Medication" } },
    { id: AllergyCategoryEnum.ENVIRONMENT, labels: { 0: "Ambiental", 1: "Environmental" } },
    { id: AllergyCategoryEnum.BIOLOGIC, labels: { 0: "Biológica", 1: "Biologic" } },
    { id: AllergyCategoryEnum.OTHER, labels: { 0: "Otro", 1: "Other" } },
];

export const ALLERGY_SEVERITY_MAP = [
    { id: AllergySeverityEnum.UNSPECIFIED, labels: { 0: "Sin especificar", 1: "Unspecified" } },
    { id: AllergySeverityEnum.MILD, labels: { 0: "Leve", 1: "Mild" } },
    { id: AllergySeverityEnum.MODERATE, labels: { 0: "Moderada", 1: "Moderate" } },
    { id: AllergySeverityEnum.SEVERE, labels: { 0: "Grave / Severa", 1: "Severe" } },
];

export const ALLERGY_CRITICALITY_MAP = [
    { id: AllergyCriticalityEnum.UNSPECIFIED, labels: { 0: "Sin especificar", 1: "Unspecified" } },
    { id: AllergyCriticalityEnum.LOW, labels: { 0: "Bajo Riesgo", 1: "Low Risk" } },
    { id: AllergyCriticalityEnum.HIGH, labels: { 0: "Alto Riesgo (Anafilaxia)", 1: "High Risk (Anaphylaxis)" } },
    { id: AllergyCriticalityEnum.UNABLE_TO_ASSESS, labels: { 0: "No Evaluable", 1: "Unable to Assess" } },
];

export const ALLERGY_STATUS_MAP = [
  { id: AllergyStatusEnum.ACTIVE, labels: { 0: "Activa", 1: "Active" } },
  { id: AllergyStatusEnum.INACTIVE, labels: { 0: "Inactiva", 1: "Inactive" } },
  { id: AllergyStatusEnum.RESOLVED, labels: { 0: "Resuelta", 1: "Resolved" } },
  { id: AllergyStatusEnum.REFUTED, labels: { 0: "Refutada", 1: "Refuted" } },
];
